import { cancellableRequest } from './request';

const PriceService = {
    calculatePrice: (booking) => cancellableRequest({ method: 'post', url: '/price/calculate', data: booking }),
    validatePromoCode: (code, serviceTypeId) =>
        cancellableRequest({ method: 'get', url: `/promo-code/validate/${serviceTypeId}/${code}` }),
};
export { PriceService };
